<template>
  <div class="main-content">
    <SideBar />
    <div class="main">
      <!-- your content here -->
      <div class="trial-active" v-if="trialActive">
        <div class="text">
          <div class="title">
            <i class="fa fa-exclamation-circle"></i>
            Your trial for {{ artist.name }} is

            {{
              trialExpired
                ? "expired"
                : `expiring in
            ${daysToTrialEnd} days`
            }}!
          </div>
          <div class="details">
            Add a payment method to prevent your links from getting suspended,
            so other artists can't claim them.
          </div>
        </div>
        <div class="button-container">
          <button @click="goToBilling" class="button-default big">
            <span>Add card</span>
          </button>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import SideBar from "@/components/Custom/SideBar";

import { S_BILLING_USER } from "@/graphql";

export default {
  components: { SideBar },
  methods: {
    goToBilling() {
      this.$router.push({ name: "Billing" });
    },
  },
  computed: {
    billingUser() {
      return this.$store.getters.getBillingUser;
    },
    artist() {
      return this.$store.getters.getArtist;
    },
    trialActive() {
      if (!this.billingUser || this.billingUser === null) {
        return false;
      }
      const status = this.billingUser.braintree_subscription_status;
      return (
        (status == "Trial" || !status) && this.billingUser.plan != "family"
      );
    },
    daysToTrialEnd() {
      const first_billing_date = this.billingUser.first_billing_date;
      const status = this.billingUser.braintree_subscription_status;
      if (!first_billing_date || status !== "Trial") return null;

      const today = new Date();
      const first = new Date(first_billing_date);
      const diff = moment(first).diff(moment(today), "days");
      return diff;
    },
    trialExpired() {
      return this.daysToTrialEnd <= 0;
    },
  },
  apollo: {
    $subscribe: {
      billingUser: {
        query: S_BILLING_USER,
        variables() {
          return { artist_id: this.artist.id };
        },
        result({ data }) {
          this.$store.commit("setBillingUser", data.users[0]);
        }
      }
    }
  }
};
</script>
<style>
body {
  margin: 0;
}
</style>
<style lang="scss" scoped>
.main-content {
  //width: 100%;
  min-height: 100vh;
  background: #1b193c;
  background: radial-gradient(
    circle,
    rgba(27, 25, 60, 1) 0%,
    rgba(11, 12, 20, 1) 100%
  );
  display: flex;
}

.sidebar {
  @media screen and (max-width: 1024px) {
    width: 100px;
  }

  width: 300px;
}

.trial-active {
  flex: 1;
  display: flex;
  background: #24224a;
  color: white;
  border-radius: 10px;
  padding: 12px 24px;
  margin: 60px;
  margin-bottom: 0;

  .text {
    display: flex;
    flex-direction: column;
    padding-right: 30px;

    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 26px;
      color: #ffffff;

      i {
        margin-right: 5px;
      }
    }

    .details {
      margin-top: 5px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }
  }

  .button-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    flex: 1;

    button {
      white-space: nowrap;
    }
  }
}

.artist-dropdown {
  background: $bg-type-2;
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 0 0 10px;
  padding: 10px;
  z-index: 100;
  border-left: 1px solid $purple;
  border-bottom: 1px solid $purple;
}

.main {
  flex: 1;
  height: 100vh;
  overflow: auto;
}

@media screen and (max-width: 1024px) {
  .main-content {
    flex-direction: column;
    position: relative;
  }
  .main {
    overflow: hidden;
  }

  .artist-dropdown {
    background: $bg-type-2;
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 0 0 0 10px;
    padding: 10px;
    z-index: 100;
    border-left: 1px solid $purple;
    border-bottom: 1px solid $purple;
  }
}

@media screen and (max-width: 670px) {
  .main-content {
    padding-bottom: 80px;
  }
}
</style>
